/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".toggle-features-modal{text-align:center}.toggle-features-modal .ig-row{padding:8px 0}.toggle-features-modal .ig-row ig-col{text-align:left}.toggle-features-modal .main-icon{color:#ccc}.toggle-features-modal .title{font-size:20px;font-weight:700;text-align:left;padding-bottom:8px;border-bottom:2px solid #0e76e6;text-transform:uppercase}.toggle-features-modal p{padding:8px 0;text-align:left;font-weight:700}@media (max-width:1080px){.col-xs-12{padding-left:0!important;padding-right:0!important}}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/toggle.is.client/toggle.is.client.modal.component.scss.ngstyle.js.pre-build-optimizer.js